export { default, type AwardsSectionProps } from './AwardsSection';
